import { render, staticRenderFns } from "./riepilogoNre.vue?vue&type=template&id=727a1676"
import script from "./riepilogoNre.vue?vue&type=script&lang=js"
export * from "./riepilogoNre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports